import { render, staticRenderFns } from "./LeftColumn.vue?vue&type=template&id=3c244bda&scoped=true"
import script from "./LeftColumn.vue?vue&type=script&lang=js"
export * from "./LeftColumn.vue?vue&type=script&lang=js"
import style0 from "./LeftColumn.vue?vue&type=style&index=0&id=3c244bda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c244bda",
  null
  
)

export default component.exports